import { cn } from '../lib/cn.js'

/** Filete laranja separando blocos. Fino, sem decoração — o guia não usa ornamento. */
export function Divider({
  tom = 'laranja',
  className,
}: {
  tom?: 'laranja' | 'amarelo' | 'sutil' | undefined
  className?: string | undefined
}) {
  return <hr className={cn('du-filete', `du-filete--${tom}`, className)} />
}
